
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("aPwmB", function(module, exports) {

$parcel$export(module.exports, "default", () => $923e50adad6a1a17$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $daJ0i = parcelRequire("daJ0i");

var $1PVpv = parcelRequire("1PVpv");

var $9Egzu = parcelRequire("9Egzu");

var $ipSX1 = parcelRequire("ipSX1");

var $isK6O = parcelRequire("isK6O");

var $88i6h = parcelRequire("88i6h");

var $8kxDg = parcelRequire("8kxDg");

var $K5Jsy = parcelRequire("K5Jsy");

var $gkwXh = parcelRequire("gkwXh");
var $aoAhY = parcelRequire("aoAhY");

var $VSDnB = parcelRequire("VSDnB");

var $knXBU = parcelRequire("knXBU");

var $cKKwC = parcelRequire("cKKwC");

var $hxJcI = parcelRequire("hxJcI");
var $iCoHH = parcelRequire("iCoHH");
var $awHT5 = parcelRequire("awHT5");
var $g2SaE = parcelRequire("g2SaE");

var $8RXs9 = parcelRequire("8RXs9");

var $6Oe8V = parcelRequire("6Oe8V");

var $3N1TD = parcelRequire("3N1TD");

var $dEtqo = parcelRequire("dEtqo");

var $2EsbE = parcelRequire("2EsbE");
function $923e50adad6a1a17$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $923e50adad6a1a17$var$linkStyle = {
    name: "14m5vmv",
    styles: "position:absolute;background:transparent;top:0;right:0;bottom:0;left:0;cursor:pointer;width:100% !important;height:100% !important"
};
const $923e50adad6a1a17$var$borderStyle = {
    name: "10uwk9w",
    styles: "position:absolute;width:100% !important;height:100% !important"
};
const $923e50adad6a1a17$var$MediaBorder = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    const borderColor = mark?.attrs.color ?? '';
    const borderWidth = mark?.attrs.size ?? 0;
    const paletteColorValue = (0, $8kxDg.hexToEditorBorderPaletteColor)(borderColor) || borderColor;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-mark-type": "border",
        "data-color": borderColor,
        "data-size": borderWidth,
        css: $923e50adad6a1a17$var$borderStyle,
        style: {
            borderRadius: `${borderWidth}px`,
            boxShadow: `0 0 0 ${borderWidth}px ${paletteColorValue}`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ipSX1.MediaBorderGapFiller), {
        borderColor: borderColor
    }), children);
};
const $923e50adad6a1a17$var$MediaLink = ({ mark: mark, children: children, onClick: onClick })=>{
    if (!mark) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    const linkHref = mark?.attrs.href;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $f8Sb3.jsx)("a", {
        href: linkHref,
        rel: "noreferrer noopener",
        onClick: onClick,
        "data-block-link": linkHref,
        css: $923e50adad6a1a17$var$linkStyle
    }, children));
};
const $923e50adad6a1a17$var$MediaAnnotation = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cKKwC.default), {
        id: mark.attrs.id,
        annotationType: mark.attrs.annotationType,
        dataAttributes: {
            'data-renderer-mark': true,
            'data-block-mark': true
        },
        // This should be fine being empty [] since the serializer serializeFragmentChild getMarkProps call always passes
        annotationParentIds: [],
        allowAnnotations: true,
        useBlockLevel: true
    }, children);
};
const $923e50adad6a1a17$var$MediaAnnotations = ({ marks: marks = [], children: children })=>{
    // Early Exit
    if (marks.length === 0) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    // Recursive marks
    const currentMark = marks[0];
    const otherMarks = marks.slice(1);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)($923e50adad6a1a17$var$MediaAnnotation, {
        key: currentMark.attrs.id,
        mark: currentMark
    }, otherMarks.length ? /*#__PURE__*/ (0, $f8Sb3.jsx)($923e50adad6a1a17$var$MediaAnnotations, {
        marks: otherMarks
    }, children) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children)));
};
const $923e50adad6a1a17$var$CommentBadge = (0, $8RXs9.default)((0, $hxJcI.CommentBadge));
const $923e50adad6a1a17$var$CommentBadgeWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $5uXOq.useState)('default');
    const [entered, setEntered] = (0, $5uXOq.useState)(false);
    const updateSubscriber = (0, $3N1TD.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $6Oe8V.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $88i6h.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $aoAhY.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($923e50adad6a1a17$var$CommentBadge, {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        ...rest
    });
};
const $923e50adad6a1a17$var$CommentBadgeNextWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $5uXOq.useState)('default');
    const [entered, setEntered] = (0, $5uXOq.useState)(false);
    const updateSubscriber = (0, $3N1TD.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $6Oe8V.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $88i6h.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $aoAhY.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iCoHH.CommentBadgeNext), {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        ...rest
    });
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $923e50adad6a1a17$var$Media extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), this.renderCard = (providers = {})=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { allowAltTextOnImages: allowAltTextOnImages, alt: alt, featureFlags: featureFlags, shouldOpenMediaViewer: allowMediaViewer, enableDownloadButton: enableDownloadButton, ssr: ssr, width: width, height: height, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false } = this.props;
            const annotationMarks = this.props.isAnnotationMark ? this.props.marks.filter(this.props.isAnnotationMark) : undefined;
            const borderMark = this.props.marks.find(this.props.isBorderMark);
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const eventHandlers = linkHref ? undefined : this.props.eventHandlers;
            const shouldOpenMediaViewer = !linkHref && allowMediaViewer;
            const isInPageInclude = mediaSingleElement?.closest('[data-node-type="include"]');
            const isIncludeExcerpt = !!mediaSingleElement?.closest('.ak-excerpt-include');
            const showCommentBadge = !!annotationMarks && !isInPageInclude && !isIncludeExcerpt;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)($923e50adad6a1a17$var$MediaLink, {
                mark: linkMark,
                onClick: this.handleMediaLinkClickFn
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($923e50adad6a1a17$var$MediaAnnotations, {
                marks: annotationMarks
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($923e50adad6a1a17$var$MediaBorder, {
                mark: borderMark
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $daJ0i.default), {
                data: {
                    [(0, $1PVpv.MEDIA_CONTEXT)]: {
                        border: !!borderMark
                    }
                }
            }, (0, $VSDnB.fg)('platform_editor_add_media_from_url_rollout') && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $g2SaE.MediaBadges), {
                mediaElement: mediaSingleElement,
                mediaWidth: width,
                mediaHeight: height,
                useMinimumZIndex: true
            }, ({ visible: visible })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, visible && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $awHT5.ExternalImageBadge), {
                    type: this.props.type,
                    url: this.props.type === 'external' ? this.props.url : undefined
                }), showCommentBadge && /*#__PURE__*/ (0, $f8Sb3.jsx)($923e50adad6a1a17$var$CommentBadgeNextWrapper, {
                    marks: annotationMarks,
                    mediaSingleElement: mediaSingleElement,
                    isDrafting: isDrafting
                }))), !(0, $VSDnB.fg)('platform_editor_add_media_from_url_rollout') && showCommentBadge && /*#__PURE__*/ (0, $f8Sb3.jsx)($923e50adad6a1a17$var$CommentBadgeWrapper, {
                marks: annotationMarks,
                mediaSingleElement: mediaSingleElement,
                width: width,
                height: height,
                isDrafting: isDrafting
            }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $isK6O.MediaCard), {
                contextIdentifierProvider: contextIdentifierProvider,
                ...this.props,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                eventHandlers: eventHandlers,
                alt: allowAltTextOnImages ? alt : undefined,
                featureFlags: featureFlags,
                shouldEnableDownloadButton: enableDownloadButton,
                ssr: ssr
            })))));
        }, this.handleMediaLinkClick = (event)=>{
            const { fireAnalyticsEvent: fireAnalyticsEvent, isLinkMark: isLinkMark, marks: marks } = this.props;
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VISITED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).LINK,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                }
            });
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const handler = (0, $K5Jsy.getEventHandler)(this.props.eventHandlers, 'link');
            if (handler) {
                const linkMark = marks.find(isLinkMark);
                handler(event, linkMark && linkHref);
            }
        };
        this.handleMediaLinkClickFn = this.handleMediaLinkClick.bind(this);
    }
    render() {
        const { providers: providers } = this.props;
        if (!providers) return this.renderCard();
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Egzu.WithProviders), {
            providers: [
                'mediaProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: providers,
            renderNode: this.renderCard
        });
    }
}
const $923e50adad6a1a17$var$MediaWithDraftAnnotation = (props)=>{
    const { hoverDraftDocumentPosition: draftPosition } = (0, $2EsbE.useAnnotationRangeState)();
    const { dataAttributes: dataAttributes } = props;
    const pos = dataAttributes && dataAttributes['data-renderer-start-pos'];
    const [position, setPosition] = (0, $5uXOq.useState)();
    const [shouldApplyDraftAnnotation, setShouldApplyDraftAnnotation] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (pos === undefined) return;
        const posToCheck = (draftPosition?.from ?? 0) + 1;
        if (draftPosition !== null && posToCheck === pos) {
            setShouldApplyDraftAnnotation(true);
            setPosition(posToCheck);
        } else if (draftPosition === null && shouldApplyDraftAnnotation) {
            setShouldApplyDraftAnnotation(false);
            setPosition(undefined);
        }
    }, [
        draftPosition,
        pos,
        shouldApplyDraftAnnotation
    ]);
    const applyDraftAnnotation = props.allowAnnotationsDraftMode && shouldApplyDraftAnnotation && position !== undefined;
    const dataAttributesWithDraftAnnotation = (0, $5uXOq.useMemo)(()=>applyDraftAnnotation ? {
            ...dataAttributes,
            'data-annotation-draft-mark': true,
            'data-renderer-mark': true
        } : dataAttributes, [
        applyDraftAnnotation,
        dataAttributes
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($923e50adad6a1a17$var$Media, {
        ...props,
        dataAttributes: dataAttributesWithDraftAnnotation,
        isDrafting: shouldApplyDraftAnnotation
    });
};
var $923e50adad6a1a17$export$2e2bcd8739ae039 = $923e50adad6a1a17$var$MediaWithDraftAnnotation;

});
parcelRegister("ipSX1", function(module, exports) {

$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $2f323c2c46d09c5b$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $2f323c2c46d09c5b$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $2f323c2c46d09c5b$export$e18e95249d813157);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $1v3g5 = parcelRequire("1v3g5");

var $cROsB = parcelRequire("cROsB");

var $eOOFp = parcelRequire("eOOFp");
function $2f323c2c46d09c5b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $2f323c2c46d09c5b$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $2f323c2c46d09c5b$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $iHYdz.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $iHYdz.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $iHYdz.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $2f323c2c46d09c5b$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $iHYdz.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $iHYdz.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $iHYdz.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $2f323c2c46d09c5b$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $eOOFp.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $eOOFp.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $eOOFp.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $2f323c2c46d09c5b$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $2f323c2c46d09c5b$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $2f323c2c46d09c5b$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $eOOFp.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $eOOFp.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $2f323c2c46d09c5b$var$getWidthIfFullWidthMode(width, containerWidth) : $2f323c2c46d09c5b$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $2f323c2c46d09c5b$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $eOOFp.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $eOOFp.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $2f323c2c46d09c5b$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $eOOFp.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $eOOFp.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $2f323c2c46d09c5b$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $2f323c2c46d09c5b$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $2f323c2c46d09c5b$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.nodeType
 * @example
 */ var $2f323c2c46d09c5b$var$_ref = {
    name: "1ejvwbh",
    styles: "@container view-page-content (min-width: 1px){max-width:100cqw;}"
};
var $2f323c2c46d09c5b$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $2f323c2c46d09c5b$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, nodeType: nodeType })=>{
    const calculatedWidth = $2f323c2c46d09c5b$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $2f323c2c46d09c5b$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $2f323c2c46d09c5b$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $2f323c2c46d09c5b$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $2f323c2c46d09c5b$var$calcMaxWidth(layout, containerWidth));
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $2f323c2c46d09c5b$var$_ref2, " ", isExtendedResizeExperienceOn && (0, $VSDnB.fg)('platform_fix_media_image_resizing') ? $2f323c2c46d09c5b$var$_ref : '', "max-width:", (0, $1v3g5.isSSR)() && !calculatedMaxWidth.endsWith('%') && (0, $VSDnB.fg)('platform_editor_fix_image_size_diff_during_ssr') ? Math.max(parseInt(calculatedWidth.replace('px', '')), parseInt(calculatedMaxWidth.replace('px', ''))) + 'px' : calculatedMaxWidth, ";", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $cROsB.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $2f323c2c46d09c5b$var$float(layout), ";margin:", $2f323c2c46d09c5b$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $cROsB.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $2f323c2c46d09c5b$var$isImageAligned(layout), ";");
};
const $2f323c2c46d09c5b$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $f8Sb3.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $2f323c2c46d09c5b$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)("position:relative;", $2f323c2c46d09c5b$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-comment-badge='true'], [data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $2f323c2c46d09c5b$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f323c2c46d09c5b$export$9e3fd9f6215dd7b6(rest)
    }, children);
$2f323c2c46d09c5b$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $2f323c2c46d09c5b$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};

});
parcelRegister("cROsB", function(module, exports) {

$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $3161276a2e2e68a3$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $3161276a2e2e68a3$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $3161276a2e2e68a3$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $3161276a2e2e68a3$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $3161276a2e2e68a3$export$de65085e667b4bf1);

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $kKuJi = parcelRequire("kKuJi");
const $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $kKuJi.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $3161276a2e2e68a3$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $3161276a2e2e68a3$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $3161276a2e2e68a3$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $3161276a2e2e68a3$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $3161276a2e2e68a3$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $3161276a2e2e68a3$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $kKuJi.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $kKuJi.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $3161276a2e2e68a3$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $kKuJi.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $kKuJi.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $iHYdz.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("kKuJi", function(module, exports) {

$parcel$export(module.exports, "calcPxFromColumns", () => $96e639534456f333$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $96e639534456f333$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $96e639534456f333$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $96e639534456f333$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $96e639534456f333$export$5e51fc02b9ada5af);

var $iHYdz = parcelRequire("iHYdz");

var $intz5 = parcelRequire("intz5");
const $96e639534456f333$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $96e639534456f333$export$adfc02948d64a4f2 = (layout)=>$96e639534456f333$var$validWidthModes.indexOf(layout) > -1;
function $96e639534456f333$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
}
function $96e639534456f333$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $96e639534456f333$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
}
function $96e639534456f333$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $96e639534456f333$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $96e639534456f333$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($96e639534456f333$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $96e639534456f333$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $96e639534456f333$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $96e639534456f333$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $iHYdz.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $iHYdz.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($96e639534456f333$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $96e639534456f333$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $96e639534456f333$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $96e639534456f333$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($96e639534456f333$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $96e639534456f333$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});
parcelRegister("intz5", function(module, exports) {

$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $7676dd27b358f47a$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $7676dd27b358f47a$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $7676dd27b358f47a$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $7676dd27b358f47a$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $7676dd27b358f47a$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $7676dd27b358f47a$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $7676dd27b358f47a$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $7676dd27b358f47a$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $7676dd27b358f47a$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $7676dd27b358f47a$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $7676dd27b358f47a$export$b4b560efd3c61856);
const $7676dd27b358f47a$export$5937600f4cc784f0 = 24;
const $7676dd27b358f47a$export$71d660e8ca5b8f73 = 320;
const $7676dd27b358f47a$export$cd11d7d46412c89b = 3;
const $7676dd27b358f47a$export$71482734bb54ac3 = 10;
const $7676dd27b358f47a$export$fd2b09475ada41cc = 12;
const $7676dd27b358f47a$export$8c5ac0b0c62a3d21 = 8;
const $7676dd27b358f47a$export$68d0abe4f03863fb = $7676dd27b358f47a$export$fd2b09475ada41cc * 2;
const $7676dd27b358f47a$export$d722b7527b1834a8 = 250;
const $7676dd27b358f47a$export$da894f7669b4e67c = 200;
const $7676dd27b358f47a$export$e13825c38da2ce1 = 100;
var $7676dd27b358f47a$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $7676dd27b358f47a$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $7676dd27b358f47a$export$4d41d008e9cd4f34 = 0.5;
const $7676dd27b358f47a$export$b4b560efd3c61856 = 'caption-placeholder';

});




parcelRegister("isK6O", function(module, exports) {

$parcel$export(module.exports, "mediaIdentifierMap", () => $89099e3fef52710a$export$7da2d00ddd5627a6);
$parcel$export(module.exports, "getClipboardAttrs", () => $89099e3fef52710a$export$92bef806f5be5d7c);
$parcel$export(module.exports, "MediaCard", () => $89099e3fef52710a$export$a6543a2e3828db2c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lmhF9 = parcelRequire("lmhF9");

var $8Ppwv = parcelRequire("8Ppwv");
var $k8DVf = parcelRequire("k8DVf");
var $3MN66 = parcelRequire("3MN66");

var $cEHh7 = parcelRequire("cEHh7");

var $c1exv = parcelRequire("c1exv");
const $89099e3fef52710a$export$7da2d00ddd5627a6 = new Map();
const $89099e3fef52710a$export$e689a46890560dbd = (doc)=>{
    if (!doc) return [];
    return (0, $lmhF9.filter)(doc, (node)=>node.type === 'media').reduce((identifierList, mediaNode)=>{
        if (mediaNode.attrs) {
            const { type: type, url: dataURI, id: id } = mediaNode.attrs;
            if (type === 'file' && id) identifierList.push({
                mediaItemType: 'file',
                id: id
            });
            else if (type === 'external' && dataURI) identifierList.push({
                mediaItemType: 'external-image',
                dataURI: dataURI,
                name: dataURI
            });
        }
        return identifierList;
    }, []);
};
class $89099e3fef52710a$export$cfff5eb155a82d30 extends (0, $5uXOq.Component) {
    async componentDidMount() {
        const { rendererContext: rendererContext, contextIdentifierProvider: contextIdentifierProvider, id: id, url: url, collection: collectionName } = this.props;
        if (contextIdentifierProvider) this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        const nodeIsInCache = id && $89099e3fef52710a$export$7da2d00ddd5627a6.has(id) || url && $89099e3fef52710a$export$7da2d00ddd5627a6.has(url);
        if (rendererContext && rendererContext.adDoc && !nodeIsInCache) $89099e3fef52710a$export$e689a46890560dbd(rendererContext.adDoc).forEach((identifier)=>{
            if (identifier.mediaItemType === 'file' && identifier.id === id) $89099e3fef52710a$export$7da2d00ddd5627a6.set(identifier.id, {
                ...identifier,
                collectionName: collectionName
            });
            else if (identifier.mediaItemType === 'external-image') $89099e3fef52710a$export$7da2d00ddd5627a6.set(identifier.dataURI, identifier);
        });
        if (id) this.saveFileState(id);
    }
    componentDidUpdate(prevProps) {
        const { id: oldId } = prevProps;
        if (this.props.id && oldId !== this.props.id) this.saveFileState(this.props.id);
    }
    componentWillUnmount() {
        const { id: id, url: dataURI } = this.props;
        if (id) $89099e3fef52710a$export$7da2d00ddd5627a6.delete(id);
        else if (dataURI) $89099e3fef52710a$export$7da2d00ddd5627a6.delete(dataURI);
    }
    renderExternal(shouldOpenMediaViewer) {
        const { cardDimensions: cardDimensions, resizeMode: resizeMode, appearance: appearance, url: url, imageStatus: imageStatus, disableOverlay: disableOverlay, alt: alt, featureFlags: featureFlags, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes } = this.props;
        if (imageStatus === 'loading' || !url) return this.renderLoadingCard();
        const identifier = {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        };
        // we need this statement for the mandatory mediaClientConfig below
        const mediaClientConfig = mediaClient?.mediaClientConfig;
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ...dataAttributes,
            "data-node-type": "media",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ppwv.default), {
                // TODO: MPT-315 - clean up after we move mediaClientConfig into FileIdentifier
                // context is not really used when the type is external and we want to render the component asap
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mediaClientConfig: mediaClientConfig,
                alt: alt,
                identifier: identifier,
                dimensions: cardDimensions,
                appearance: appearance,
                resizeMode: resizeMode,
                disableOverlay: disableOverlay,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($89099e3fef52710a$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                ssr: ssr?.mode,
                shouldHideTooltip: false
            })
        }));
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, fileState: fileState } = this.state;
        const { id: id, alt: alt, type: type, collection: collection, occurrenceKey: occurrenceKey, cardDimensions: cardDimensions, resizeMode: resizeMode, disableOverlay: disableOverlay, useInlinePlayer: useInlinePlayer, originalDimensions: originalDimensions, shouldOpenMediaViewer: forceOpenMediaViewer, featureFlags: featureFlags, shouldEnableDownloadButton: shouldEnableDownloadButton, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes } = this.props;
        const isMobile = false;
        const shouldPlayInline = useInlinePlayer !== undefined ? useInlinePlayer : true;
        const isInlinePlayer = isMobile ? false : shouldPlayInline;
        const onCardClick = this.getOnCardClickCallback(isInlinePlayer);
        const shouldOpenMediaViewer = typeof forceOpenMediaViewer === 'boolean' ? forceOpenMediaViewer : !isMobile && !onCardClick;
        if (type === 'external') return this.renderExternal(shouldOpenMediaViewer);
        if (type === 'link') return null;
        const mediaClientConfig = !!ssr ? ssr.config : mediaClient?.mediaClientConfig;
        if (!mediaClientConfig || !id) return this.renderLoadingCard();
        if (!id || type !== 'file') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8DVf.CardError), {
            dimensions: cardDimensions
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = {
            id: id,
            mediaItemType: 'file',
            collectionName: collection,
            occurrenceKey: occurrenceKey
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ...$89099e3fef52710a$export$92bef806f5be5d7c({
                id: id,
                alt: alt,
                collection: collection,
                contextIdentifierProvider: contextIdentifierProvider,
                originalDimensions: originalDimensions,
                fileState: fileState
            }),
            ...dataAttributes,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ppwv.default), {
                identifier: identifier,
                alt: alt,
                contextId: contextId,
                mediaClientConfig: mediaClientConfig,
                dimensions: cardDimensions,
                originalDimensions: originalDimensions,
                onClick: onCardClick,
                resizeMode: resizeMode,
                isLazy: !isMobile,
                disableOverlay: disableOverlay,
                useInlinePlayer: isInlinePlayer,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($89099e3fef52710a$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                shouldEnableDownloadButton: shouldEnableDownloadButton,
                ssr: ssr?.mode,
                shouldHideTooltip: isMobile
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {}, this.saveFileState = async (id)=>{
            const { collection: collectionName, mediaClient: mediaClient } = this.props;
            const options = {
                collectionName: collectionName
            };
            try {
                if (mediaClient) {
                    const fileState = await mediaClient.file.getCurrentState(id, options);
                    this.setState({
                        fileState: fileState
                    });
                }
            } catch (error) {
            // do not set state on error
            }
        }, this.renderLoadingCard = ()=>{
            const { cardDimensions: cardDimensions } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3MN66.CardLoading), {
                dimensions: cardDimensions,
                interactionName: "renderer-media-card-loading"
            });
        }, /**
	 * We want to call provided `eventHandlers.media.onClick` when it's provided,
	 * but we also don't want to call it when it's a video and inline video player is enabled.
	 * This is due to consumers normally process this onClick call by opening media viewer and
	 * we don't want that to happened described above text.
	 */ this.getOnCardClickCallback = (isInlinePlayer)=>{
            const { eventHandlers: eventHandlers } = this.props;
            if (eventHandlers && eventHandlers.media && eventHandlers.media.onClick) return (result, analyticsEvent)=>{
                const isVideo = result.mediaItemDetails && result.mediaItemDetails.mediaType === 'video';
                const isVideoWithInlinePlayer = isInlinePlayer && isVideo;
                if (!isVideoWithInlinePlayer && eventHandlers && eventHandlers.media && eventHandlers.media.onClick) eventHandlers.media.onClick(result, analyticsEvent);
            };
            return undefined;
        };
    }
}
const $89099e3fef52710a$export$92bef806f5be5d7c = ({ id: id, alt: alt, collection: collection, contextIdentifierProvider: contextIdentifierProvider, originalDimensions: originalDimensions, fileState: fileState })=>{
    const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
    const width = originalDimensions && originalDimensions.width;
    const height = originalDimensions && originalDimensions.height;
    let fileName = 'file'; // default name is needed for Confluence
    let fileSize = 1;
    let fileMimeType = '';
    if (fileState && fileState.status !== 'error') {
        fileSize = fileState.size;
        fileName = fileState.name;
        fileMimeType = fileState.mimeType;
    }
    return {
        'data-context-id': contextId,
        'data-type': 'file',
        'data-node-type': 'media',
        'data-width': width,
        'data-height': height,
        'data-id': id,
        'data-collection': collection,
        'data-file-name': fileName,
        'data-file-size': fileSize,
        'data-file-mime-type': fileMimeType,
        'data-alt': alt
    };
};
const $89099e3fef52710a$export$fae4803d1ca121c8 = (props)=>{
    const mediaClient = (0, $5uXOq.useContext)((0, $cEHh7.MediaClientContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)($89099e3fef52710a$export$cfff5eb155a82d30, {
        ...props,
        mediaClient: mediaClient
    });
};
const $89099e3fef52710a$export$a6543a2e3828db2c = (0, $c1exv.withImageLoader)($89099e3fef52710a$export$fae4803d1ca121c8);

});
parcelRegister("lmhF9", function(module, exports) {

$parcel$export(module.exports, "filter", () => $cb7d90be6f5f5975$export$3dea766d36a8935f);

var $l1C1k = parcelRequire("l1C1k");
function $cb7d90be6f5f5975$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});

parcelRegister("8Ppwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf4e207ffdf42736$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $3MN66 = parcelRequire("3MN66");

var $8Ec39 = parcelRequire("8Ec39");
const $cf4e207ffdf42736$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $cf4e207ffdf42736$var$CardLoadingWithContext = ()=>{
    const props = (0, $5uXOq.useContext)($cf4e207ffdf42736$var$MediaCardContext);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3MN66.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

const $cf4e207ffdf42736$var$MediaCardWithMediaClientProvider = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("6KL9d")).then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($cf4e207ffdf42736$var$CardLoadingWithContext, {})
});
const $cf4e207ffdf42736$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ec39.default), {
        name: "media-card",
        mode: "list",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($cf4e207ffdf42736$var$MediaCardContext.Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cf4e207ffdf42736$var$MediaCardWithMediaClientProvider, {
                ...props
            })
        })
    });
};
$cf4e207ffdf42736$var$CardLoader.preload = ()=>$cf4e207ffdf42736$var$MediaCardWithMediaClientProvider.preload();
var $cf4e207ffdf42736$export$2e2bcd8739ae039 = $cf4e207ffdf42736$var$CardLoader;

});
parcelRegister("3MN66", function(module, exports) {

$parcel$export(module.exports, "CardLoading", () => $0a046622b3e4af34$export$5d25853fd6bdf402);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lv9SR = parcelRequire("lv9SR");

var $9UBB8 = parcelRequire("9UBB8");

var $eZJjh = parcelRequire("eZJjh");
class $0a046622b3e4af34$export$5d25853fd6bdf402 extends (0, $5uXOq.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = this.props;
        const dimensions = (0, $lv9SR.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UBB8.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                interactionName: interactionName || 'media-card-loading'
            })
        });
    }
}

});
parcelRegister("lv9SR", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $d8ce749d15267dc5$export$36acad525b1fb57b);
const $d8ce749d15267dc5$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("9UBB8", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $bd391a179607a821$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dl3Lm = parcelRequire("dl3Lm");
const $bd391a179607a821$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $dl3Lm.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("dl3Lm", function(module, exports) {

$parcel$export(module.exports, "wrapperStyles", () => $4fa78fc186c274b2$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9Kxjq = parcelRequire("9Kxjq");

const $4fa78fc186c274b2$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9Kxjq.center), {
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9Kxjq.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("9Kxjq", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $6f73a55d3fdeb63f$export$a5b94313d6908893);
$parcel$export(module.exports, "size", () => $6f73a55d3fdeb63f$export$346677f925de839c);
$parcel$export(module.exports, "center", () => $6f73a55d3fdeb63f$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $6f73a55d3fdeb63f$export$7a57f79000377ca2);

var $k5uoT = parcelRequire("k5uoT");
const $6f73a55d3fdeb63f$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $6f73a55d3fdeb63f$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $6f73a55d3fdeb63f$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $6f73a55d3fdeb63f$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $6f73a55d3fdeb63f$export$7a57f79000377ca2 = `
  border-radius: ${(0, $k5uoT.borderRadius)()}px;
`;
const $6f73a55d3fdeb63f$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${(0, $k5uoT.borderRadius)()}px;
  border-bottom-right-radius: ${(0, $k5uoT.borderRadius)()}px;
`;
const $6f73a55d3fdeb63f$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});

var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';




parcelRegister("6KL9d", function(module, exports) {

let $4eab9c7e95b9bfbf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4eab9c7e95b9bfbf$var$load("76n7a"),
    $4eab9c7e95b9bfbf$var$load("l253H"),
    $4eab9c7e95b9bfbf$var$load("ffQaD"),
    $4eab9c7e95b9bfbf$var$load("kvRbA"),
    $4eab9c7e95b9bfbf$var$load("7dh7d")
]).then(()=>parcelRequire('iIet0'));

});


parcelRegister("k8DVf", function(module, exports) {

$parcel$export(module.exports, "CardError", () => $bebc75b3de85b938$export$f7f7efdefcc02999);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $41YDQ = parcelRequire("41YDQ");

var $9UBB8 = parcelRequire("9UBB8");

var $lv9SR = parcelRequire("lv9SR");
class $bebc75b3de85b938$export$f7f7efdefcc02999 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            size: 'medium'
        };
    }
    render() {
        const dimensions = (0, $lv9SR.getDimensionsWithDefault)(this.props.dimensions);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UBB8.Wrapper), {
            dimensions: dimensions,
            children: this.icon
        });
    }
    get icon() {
        const { size: size } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $41YDQ.ErrorIcon), {
            size: size
        });
    }
}

});
parcelRegister("41YDQ", function(module, exports) {

$parcel$export(module.exports, "ErrorIcon", () => $59f60c7732798701$export$19bc16ee58e19b3d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $gb7Oz = parcelRequire("gb7Oz");

var $5skY0 = parcelRequire("5skY0");
class $59f60c7732798701$export$19bc16ee58e19b3d extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            size: 'small'
        };
    }
    render() {
        const { size: size } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $5skY0.errorIconWrapperStyles)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gb7Oz))), {
            color: "currentColor",
            label: "Error",
            LEGACY_size: size
        })));
    }
}

});
parcelRegister("gb7Oz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77723dece3c67bedf7bcbbec84e5d004>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc73bc3d72b7857d$var$_react = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bc73bc3d72b7857d$var$_warning = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("34Rrn")));

var $bc73bc3d72b7857d$var$_warning2 = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("hD8l9")));
function $bc73bc3d72b7857d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc73bc3d72b7857d$var$WarningIcon = (props)=>/*#__PURE__*/ $bc73bc3d72b7857d$var$_react.default.createElement($bc73bc3d72b7857d$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $bc73bc3d72b7857d$var$_warning2.default
    }, props));
$bc73bc3d72b7857d$var$WarningIcon.Name = 'WarningIconMigration';
var $bc73bc3d72b7857d$var$_default = module.exports.default = $bc73bc3d72b7857d$var$WarningIcon;

});
parcelRegister("hD8l9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd5c8c5b40614fc0$var$_react = $cd5c8c5b40614fc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cd5c8c5b40614fc0$var$_warning = $cd5c8c5b40614fc0$var$_interopRequireDefault((parcelRequire("34Rrn")));
function $cd5c8c5b40614fc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cd5c8c5b40614fc0$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $cd5c8c5b40614fc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $cd5c8c5b40614fc0$var$_warning.default
    }));
$cd5c8c5b40614fc0$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $cd5c8c5b40614fc0$var$_default = module.exports.default = $cd5c8c5b40614fc0$var$EditorWarningIcon;

});


parcelRegister("5skY0", function(module, exports) {

$parcel$export(module.exports, "errorIconWrapperStyles", () => $a3ade93d7e8f4764$export$8dcf6b831a37de79);
function $a3ade93d7e8f4764$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a3ade93d7e8f4764$export$8dcf6b831a37de79 = {
    name: "1fo963f",
    styles: "display:flex;color:var(--ds-icon-warning, #ff991f)"
};

});



parcelRegister("c1exv", function(module, exports) {

$parcel$export(module.exports, "withImageLoader", () => $9600f65038d22dcf$export$9b0f795b2e33f057);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $9600f65038d22dcf$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
        /**
		 *
		 * @example
		 */ componentDidMount() {
            this.fetchImage(this.props);
        }
        /**
		 *
		 * @param nextProps
		 * @example
		 */ // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        /**
		 *
		 * @example
		 */ componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        /**
		 *
		 * @param root0
		 * @param root0.url
		 * @example
		 */ fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        /**
		 *
		 * @example
		 */ render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $9600f65038d22dcf$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $9600f65038d22dcf$export$9b0f795b2e33f057 = (Wrapped)=>{
    if ((0, $VSDnB.fg)('platform_editor_react18_phase2_v2') || (0, $VSDnB.fg)('platform_editor_react18_phase2_v2_extended')) return $9600f65038d22dcf$var$withImageLoaderNew(Wrapped);
    return $9600f65038d22dcf$export$3a0bcc6ff2e20f36(Wrapped);
};

});


parcelRegister("8kxDg", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $7e5c3b5be97f46f1$export$bad3c41dd33cb4bc);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $7e5c3b5be97f46f1$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $7e5c3b5be97f46f1$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $7e5c3b5be97f46f1$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #091E4224)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #758195)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #172B4D)"
};

});

parcelRegister("aoAhY", function(module, exports) {

$parcel$export(module.exports, "RESOLVE_METHOD", () => $f2a29bd58b4d37e3$export$ecd1fed429542b49);
$parcel$export(module.exports, "VIEW_METHOD", () => $f2a29bd58b4d37e3$export$9cf3651d97128b9c);
var $f2a29bd58b4d37e3$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $f2a29bd58b4d37e3$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});

});

parcelRegister("hxJcI", function(module, exports) {

$parcel$export(module.exports, "CommentBadge", () => $bb75829b3307fc4d$export$ef88b752358da42);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lFKmC = parcelRequire("lFKmC");

var $9yOBd = parcelRequire("9yOBd");

var $iHYdz = parcelRequire("iHYdz");

var $bFmnZ = parcelRequire("bFmnZ");

var $DBbS0 = parcelRequire("DBbS0");

var $3bDjY = parcelRequire("3bDjY");

var $1yurT = parcelRequire("1yurT");
const $bb75829b3307fc4d$var$commentBadgeWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    // closest parent element with position relative is .resizer-hover-zone, which includes 10px padding
    right: '2px',
    top: '2px',
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $iHYdz.akEditorUnitZIndex) * 10
});
const $bb75829b3307fc4d$var$commentBadgeEditorOverrides = (badgeOffsetRight)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: badgeOffsetRight,
        zIndex: 100
    });
const $bb75829b3307fc4d$export$1019384fb8540123 = (width, height)=>{
    // width is the original width of image, not resized or currently rendered to user. Defaulting to medium for now
    return width && width < 70 || height && height < 70 ? 'small' : 'medium';
};
const $bb75829b3307fc4d$export$ef88b752358da42 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ intl: intl, width: width, height: height, status: status = 'default', mediaSingleElement: mediaSingleElement, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, badgeOffsetRight: badgeOffsetRight }, ref)=>{
    const [badgeSize, setBadgeSize] = (0, $5uXOq.useState)($bb75829b3307fc4d$export$1019384fb8540123(width, height));
    const title = intl.formatMessage((0, $1yurT.commentMessages).viewCommentsOnMedia);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setBadgeSize($bb75829b3307fc4d$export$1019384fb8540123(width, height));
        }));
        if (mediaSingleElement instanceof HTMLElement) observer.observe(mediaSingleElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement
    ]);
    const badgeDimensions = badgeSize === 'medium' ? '24px' : '16px';
    const colourToken = (0, $5uXOq.useMemo)(()=>{
        switch(status){
            case 'active':
                return "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)";
            case 'entered':
                return "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)";
            default:
                return "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        css: badgeOffsetRight ? [
            $bb75829b3307fc4d$var$commentBadgeWrapper,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $bb75829b3307fc4d$var$commentBadgeEditorOverrides(badgeOffsetRight)
        ] : $bb75829b3307fc4d$var$commentBadgeWrapper,
        // This is needed so that mediaWrapperStyle in editor/editor-common/src/ui/MediaSingle/styled.tsx
        // can target the correct div
        "data-comment-badge": "true"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9yOBd.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: badgeDimensions,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: badgeDimensions,
            background: colourToken,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center'
        },
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        iconAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))), {
            label: title,
            spacing: "spacious",
            color: "currentColor",
            LEGACY_size: badgeSize,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($DBbS0)))
        })
    })));
});

});
parcelRegister("bFmnZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e4e36d6c115ce9$var$_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e4e36d6c115ce9$var$CommentIcon = (props)=>/*#__PURE__*/ $87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;

});

parcelRegister("DBbS0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07707de1f3ce8a8c$var$_react = $07707de1f3ce8a8c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $07707de1f3ce8a8c$var$_comment = $07707de1f3ce8a8c$var$_interopRequireDefault((parcelRequire("bFmnZ")));
function $07707de1f3ce8a8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $07707de1f3ce8a8c$var$CommentIcon = (props)=>/*#__PURE__*/ $07707de1f3ce8a8c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $07707de1f3ce8a8c$var$_comment.default
    }));
$07707de1f3ce8a8c$var$CommentIcon.displayName = 'CommentIcon';
var $07707de1f3ce8a8c$var$_default = module.exports.default = $07707de1f3ce8a8c$var$CommentIcon;

});

parcelRegister("1yurT", function(module, exports) {

$parcel$export(module.exports, "commentMessages", () => $5b3ec0af650147e8$export$4c0d145df60cfb04);

var $7VHMR = parcelRequire("7VHMR");
const $5b3ec0af650147e8$export$4c0d145df60cfb04 = (0, $7VHMR.defineMessages)({
    addCommentOnMedia: {
        id: 'fabric.editor.addCommentOnMedia',
        defaultMessage: 'Add comment',
        description: 'Add a comment for this media (image/video)'
    },
    viewCommentsOnMedia: {
        id: 'fabric.editor.viewCommentOnMedia',
        defaultMessage: 'View comments',
        description: 'View a existing comment for this media (image/video)'
    },
    viewAndAddCommentsOnMedia: {
        id: 'fabric.editor.viewAndAddCommentsOnMedia',
        defaultMessage: 'View and add comments',
        description: 'View and add comments for this image'
    }
});

});


parcelRegister("iCoHH", function(module, exports) {

$parcel$export(module.exports, "CommentBadgeNext", () => $9e975775c2ae417d$export$d5da84b0136a0cc4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bFmnZ = parcelRequire("bFmnZ");

var $DBbS0 = parcelRequire("DBbS0");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $1yurT = parcelRequire("1yurT");
const $9e975775c2ae417d$var$baseStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius'
});
const $9e975775c2ae417d$var$mediumBadgeStyles = (0, $8CUq3.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $9e975775c2ae417d$export$d5da84b0136a0cc4 = ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $koVbs.default)();
    const title = intl.formatMessage((0, $1yurT.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $5uXOq.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        position: "top",
        content: title,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
            xcss: [
                $9e975775c2ae417d$var$baseStyles,
                $9e975775c2ae417d$var$mediumBadgeStyles
            ],
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))), {
                label: title,
                spacing: "spacious",
                color: "currentColor",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($DBbS0)))
            })
        })
    });
};

});

parcelRegister("awHT5", function(module, exports) {

$parcel$export(module.exports, "ExternalImageBadge", () => $b0180c5335256e66$export$66bf2ed7a5d4691f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $1jWct = parcelRequire("1jWct");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $6Vbmv = parcelRequire("6Vbmv");
const $b0180c5335256e66$var$baseStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $b0180c5335256e66$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com'
];
const $b0180c5335256e66$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    return Boolean(hostname && $b0180c5335256e66$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $b0180c5335256e66$export$66bf2ed7a5d4691f = ({ type: type, url: url })=>{
    const intl = (0, $koVbs.default)();
    const message = intl.formatMessage((0, $6Vbmv.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $b0180c5335256e66$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
        padding: "space.050",
        xcss: $b0180c5335256e66$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
                    LEGACY_size: "small",
                    label: message
                })
            })
        ]
    });
};

});
parcelRegister("6Vbmv", function(module, exports) {

$parcel$export(module.exports, "externalMediaMessages", () => $617bb862e54519f7$export$8e36294abfabe45e);

var $7VHMR = parcelRequire("7VHMR");
const $617bb862e54519f7$export$8e36294abfabe45e = (0, $7VHMR.defineMessages)({
    externalMediaFile: {
        id: 'fabric.editor.externalMediaFile',
        defaultMessage: 'External media file',
        description: 'External media file'
    }
});

});


parcelRegister("g2SaE", function(module, exports) {

$parcel$export(module.exports, "MediaBadges", () => $2cfb9150d34342e8$export$6a31fc38737d0e58);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $2cfb9150d34342e8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $2cfb9150d34342e8$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $2cfb9150d34342e8$var$hackedZIndexStyles = (0, $8CUq3.xcss)({
    // @ts-ignore
    zIndex: '1'
});
const $2cfb9150d34342e8$var$resizeOffsetStyles = (0, $8CUq3.xcss)({
    right: 'space.150'
});
const $2cfb9150d34342e8$var$getBadgeVisible = (width, height)=>{
    return width && width < $2cfb9150d34342e8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $2cfb9150d34342e8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $2cfb9150d34342e8$export$6a31fc38737d0e58 = ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $5uXOq.useState)($2cfb9150d34342e8$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $5uXOq.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($2cfb9150d34342e8$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) === 0) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        xcss: [
            $2cfb9150d34342e8$var$containerStyles,
            useMinimumZIndex && $2cfb9150d34342e8$var$hackedZIndexStyles,
            extendedResizeOffset && $2cfb9150d34342e8$var$resizeOffsetStyles
        ],
        children: children
    });
};

});



//# sourceMappingURL=@atlaskit-internal_renderer-node_Media.7b9f5190.js.map
